import CreateNewFolderModal from "./createNewFolderModal/createNewFolderModal.index";
import LinkUploadModal from "./LinkUploadModal/linkUploadModal.index";
import RenameModal from "./renameModal/renameModal.index";
import InformationModal from "./informationModal/informationModal.index";
import CutModal from "./cutModal/cutModal.index";
import ShareModal from "./shareModal/shareModal.index";
import SharedCutModal from "../../sharedFileManager/cutModal/cutModal.index";
import PublicLinkModal from "./publicLinkModal/publicLinkModal";
import FolderPublicLinksModal from "./publicLinkModal/folderPublicLinksModal/folderPublicLinksModal";
import { getFileExtension, isFolder, previewValidFormats } from "../../../../../scripts/helpers";
import {
    handleSetDeleteConfirmationModalStatus,
    handleSetDownloadConfirmationModalStatus,
    handleSetDownloadModalStatus,
    handleSetTrashConfirmationModalStatus,
    handleSetUnshareConfimrationModalStatus
} from "../../fileManager.actions";
import { deleteResources, downloadResource, trashResources, unsharedResources } from "../../fileManager.function";
import ConfirmationModal from "../../../confirmationModal/confirmationModal.index";
import { Suspense, useEffect, useState } from "react";
import { ResourceAccessEnum, ResourceType } from "../../../../../interfaces/general";
import CheckBox from "../../../checkbox/checkbox.index";
import DownloadAlertModal from "./donwloadAlertModal/downloadAlertModal.index";
import { setDownloadConfirmationModalStatus } from "../../../../../redux/slices/fileManagerSlice";
import { useAppDispatch, useAppSelector } from "../../../../../redux/hooks";
import VersioningModal from "./versioningModal/versioningModal.index";
import { toast } from "mobin-toast";
import NameDisplay from "../../../displayFaEn/showCorrectName/showCorrectName.index";
import { setUpdateStatusCode } from "../../../../../redux/slices/duplicatedFilesSlice";
import { v4 as uuidv4 } from "uuid";
import { toastMessages } from "../../../../../scripts/toastMessages";
import { shallowEqual } from "react-redux";
import PreviewModal from "../previewModal/previewModal.index";

export default function Modals({ mode, fileInput = null }: any): JSX.Element {
    const dispatch = useAppDispatch();
    const {
        trashConfirmationModalStatus,
        previewModalStatus,
        selectedResources,
        filteredResources,
        deleteConfirmationModalStatus,
        unshareConfirmationModalStatus,
        downloadConfirmationModalStatus
    } = useAppSelector(
        ({
            fileManager: {
                trashConfirmationModalStatus,
                previewModalStatus,
                selectedResources,
                filteredResources,
                deleteConfirmationModalStatus,
                unshareConfirmationModalStatus,
                downloadConfirmationModalStatus
            }
        }) => ({
            trashConfirmationModalStatus,
            previewModalStatus,
            selectedResources,
            filteredResources,
            deleteConfirmationModalStatus,
            unshareConfirmationModalStatus,
            downloadConfirmationModalStatus
        }),
        shallowEqual
    );
    const [trashShared, setTrashShared] = useState(false);
    const params = new URLSearchParams(window.location.search);
    const [deleteForEver, setDeleteForEver] = useState(false);

    useEffect(() => {
        if (!trashConfirmationModalStatus) {
            setDeleteForEver(false);
        }
    }, [trashConfirmationModalStatus]);

    const handleDownloadResource = () => {
        if (localStorage.getItem("HAMRAHI_DOWNLOAD_ALERT")) {
            downloadResource();
        } else {
            handleSetDownloadModalStatus(true);
        }
    };

    return (
        <>
            <CreateNewFolderModal />
            <LinkUploadModal />
            <RenameModal />
            <PublicLinkModal mode={mode} />
            <FolderPublicLinksModal />
            <InformationModal />
            {previewModalStatus && (
                <Suspense>
                    <PreviewModal
                        resource={selectedResources[0]}
                        filteredResources={filteredResources.filter(
                            (resource: any) => !isFolder(resource) && previewValidFormats.includes(getFileExtension(resource.name)!)
                        )}
                    />
                </Suspense>
            )}
            <ConfirmationModal
                modalType={"DELETE"}
                status={trashConfirmationModalStatus}
                onClose={() => {
                    handleSetTrashConfirmationModalStatus(false);
                    setDeleteForEver(false);
                }}
                onSubmit={
                    deleteForEver
                        ? () =>
                              deleteResources().then(() => {
                                  handleSetTrashConfirmationModalStatus(false);
                                  dispatch(setUpdateStatusCode(uuidv4()));
                              })
                        : () =>
                              trashResources().then(() => {
                                  handleSetTrashConfirmationModalStatus(false);
                                  dispatch(setUpdateStatusCode(uuidv4()));
                              })
                }
                submitButtonText="حذف"
                cancelButtonText="انصراف"
                text={`آیا از حذف ${selectedResources.length === 1 ? "این " : `این ${selectedResources.length}`} فایل مطمئن هستید؟`}
            >
                {" "}
                <div className="mb-2" />
                {selectedResources.length === 1 && (
                    <div className="text-[14px] text-secondary-500 mb-4 w-full">
                        <NameDisplay TextInput={selectedResources[0].name} />
                    </div>
                )}
                <hr className="w-full" />
                <div className="w-full mt-4">
                    <CheckBox label="حذف برای همیشه" onChange={(value) => setDeleteForEver(value)} defaultValue={deleteForEver} />
                    <p className="text-[14px] leading-6 text-secondary-500">
                        در صورت انتخاب این گزینه فایل برای همیشه حذف خواهد شد در غیر این صورت به سطل زباله منتقل خواهد شد.
                    </p>
                </div>
            </ConfirmationModal>
            <ConfirmationModal
                modalType={"DELETE"}
                status={deleteConfirmationModalStatus}
                onClose={() => handleSetDeleteConfirmationModalStatus(false)}
                onSubmit={() =>
                    deleteResources().then(() => {
                        handleSetDeleteConfirmationModalStatus(false);
                        dispatch(setUpdateStatusCode(uuidv4()));
                    })
                }
                submitButtonText="بله"
                cancelButtonText="خیر"
                text="آیا می‌خواهید فایل‌ها را از سطل زباله حذف کنید؟"
            />
            <ConfirmationModal
                modalType={"DELETE"}
                status={unshareConfirmationModalStatus}
                onClose={() => handleSetUnshareConfimrationModalStatus(false)}
                onSubmit={() => {
                    return unsharedResources(params.has("root") ? true : trashShared).then((data: any) => {
                        handleSetUnshareConfimrationModalStatus(false);
                        if (!data.trash) toast({ title: toastMessages(29), type: "success" });
                        setTrashShared(false);
                    });
                }}
                submitButtonText="بله"
                cancelButtonText="خیر"
                text="آیا می‌خواهید فایل‌ها را حذف کنید؟"
            >
                {selectedResources.every((resource: ResourceType) => resource.shareData?.access === ResourceAccessEnum.WRITE) &&
                    !params.has("root") &&
                    selectedResources.length > 0 && (
                        <div className="mt-4">
                            <CheckBox label="حذف برای همه" onChange={(value) => setTrashShared(value)} defaultValue={trashShared} />
                        </div>
                    )}
            </ConfirmationModal>
            <ConfirmationModal
                modalType={"ACTION"}
                status={downloadConfirmationModalStatus}
                onClose={() => handleSetDownloadConfirmationModalStatus(false)}
                onSubmit={() => {
                    handleDownloadResource();
                    dispatch(setDownloadConfirmationModalStatus(false));
                }}
                submitButtonText="دانلود فایل"
                cancelButtonText="لغو"
                text="متأسفانه، فایل قابل نمایش نیست. در صورت تمایل می‌توانید دانلود نمایید؟"
                rotateButtons={true}
            />
            <DownloadAlertModal />
            <CutModal />
            <SharedCutModal />
            <ShareModal />
            <VersioningModal fileInput={fileInput} />
        </>
    );
}
